import useSWR from 'swr';
import { swrKeys } from '@shared/api/swr/keys';

export const useProjects = () => {
  const { data, error, isLoading, mutate } = useSWR(swrKeys.projects.all());

  return {
    projects: data ?? [],
    isLoading,
    error,
    mutate,
  };
};
